export default "__VITE_ASSET__06488555__"